import React, { useEffect, useMemo, useState } from "react";

import Button from "@cayuse/shared-react.components.button";
import ButtonGroup from "@cayuse/shared-react.components.button-group";
import Modal from "@cayuse/shared-react.components.modal";

import { AddUnnamedMember } from "components/BudgetBuilder/ResearchTeam/AddMemberModal/AddUnnamedMember";
import { useDictionary } from "hooks";
import { addNewResearchTeamMember } from "store/actions/budgetBuilder";
import { fetchPicklistOptions } from "store/actions/picklists";

const AddMemberModal = ({ onClose, isOpen }) => {
	const dictionary = useDictionary("budgetBuilder.components.AddMemberModal");
	const [ userData, setUserData ] = useState({});
	const valid = useMemo(() => {
		return userData.association
				&& userData.role
				&& (
					!isNaN(userData.calendarMonths)
					|| !isNaN(userData.academicMonths)
					|| !isNaN(userData.summerMonths)
				);
	}, [ userData ]);


	const onSaveNewMember = () => addNewResearchTeamMember(userData).then(() => handleClose());

	const handleClose = () => {
		setUserData({});
		onClose();
	};

	useEffect(() => {
		fetchPicklistOptions("units");
		fetchPicklistOptions("researchTeamRoles");
	}, []);

	return (
		<Modal
			closeIcon
			closeOnEscape={true}
			onClose={handleClose}
			open={isOpen}
			ariaLabel={dictionary.modalHeader || "Add Person"}
		>
			<Modal.Header className="whiteOnBlue">
				<h2>{dictionary.modalHeader || "Add Person"}</h2>
			</Modal.Header>
			<Modal.Content>
				<p>{dictionary.subtitle || "Add a person to be named later (i.e. a postdoc or lab tech who is not yet hired)"}</p>
				<AddUnnamedMember
					setUserData={setUserData}
					userData={userData}
				/>
			</Modal.Content>
			<Modal.Actions>
				<ButtonGroup>
					<Button secondary onClick={onClose}>
						{dictionary.cancel || "Cancel"}
					</Button>
					<Button primary onClick={onSaveNewMember} disabled={!valid}>
						{dictionary.add || "Add"}
					</Button>
				</ButtonGroup>
			</Modal.Actions>
		</Modal>
	);
};

export default AddMemberModal;
